import { atom } from 'jotai';

export const EXCLUDE_SOLD_OUT_FILTER = '품절상품 제외';

export const itemFilterAtom = atom<string[]>([]);

export const itemColumnsAtom = atom(2);
